import { Component, Input, ElementRef, ViewChild, AfterContentInit } from "@angular/core";
import { RiskFactor } from "@app2/clients/types/alert-typedefs";


@Component({
    selector: "uba-panels",
    template: `
        <div class="uba-panels">
            <span *ngFor="let riskFactor of riskFactors; index as i">
                <div class="uba-panel-box" [attr.test-id]="'risk-factor-'+i">
                    <div class="uba-score-impact">
                        <div class="uba-panel-title" #riskFactorTitle>
                            <span test-id="risk-factor-name"
                                  [matTooltip]="hasTitleOverflow ? ('UBA_RISK_FACTOR_' + riskFactor.name | localize) : ''">
                                {{ "UBA_RISK_FACTOR_" + riskFactor.name | localize }}
                            </span>
                        </div>
                        <div class="uba-score">
                            <ng-container *ngIf="!riskFactor.newValues.length && !riskFactor.oldValues.length; else multipleVals">
                                <span class="no-dropdown" test-id="risk-factor-only-one-val">
                                    {{ riskFactor.newValues.length }}
                                </span>
                            </ng-container>
                            <ng-template #multipleVals>
                                <ds-dropdown [absoluteWidth]="'240px'"
                                             test-id="risk-factor-dropdown">
                                    <div id="ds-dropdown-trigger" class="dropdown-value" test-id="risk-factor-multiple-vals"
                                         [matTooltip]="'RISK_FACTOR_NEW' | localize">
                                        {{ riskFactor.newValues.length }}
                                    </div>
                                    <div id="ds-dropdown-header-row">
                                        <div class="uba-panel-values dropdown-values">
                                            <div class="uba-panel-to-from">
                                                {{ "RISK_FACTOR_KNOWN" | localize }}
                                            </div>
                                            <div>
                                                <span *ngFor="let riskFactorOldValue of riskFactor.oldValues; index as i"
                                                      [attr.test-id]="'risk-factor-old-value-'+i">
                                                    {{ riskFactorOldValue }} <br>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="ds-dropdown-footer-row">
                                        <div class="uba-panel-values dropdown-values">
                                            <div class="uba-panel-to-from">
                                                {{ "RISK_FACTOR_NEW" | localize }}
                                            </div>
                                            <div>
                                                <span *ngFor="let riskFactorNewValue of riskFactor.newValues; index as i"
                                                      [attr.test-id]="'risk-factor-new-value-'+i">
                                                    {{ riskFactorNewValue }} <br>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </ds-dropdown>
                            </ng-template>
                        </div>
                    </div>

                    <div class="uba-panel-values">
                        <div class="uba-panel-to-from">{{ "RISK_FACTOR_KNOWN" | localize }}</div>
                        <div class="uba-preview" test-id="risk-factor-old-preview">
                            {{ riskFactor.oldValues.join(", ") }}
                        </div>
                    </div>
                    <div class="uba-panel-values">
                        <div class="uba-panel-to-from">{{ "RISK_FACTOR_NEW" | localize }}</div>
                        <div class="uba-preview" test-id="risk-factor-new-preview">
                            {{ riskFactor.newValues.join(", ") }}
                        </div>
                    </div>
                    <div class="uba-panel-bar"></div>

                    <span class="uba-score-impact">
                        {{ "SCORE_IMPACT" | localize }}
                        <div class="uba-score"
                             test-id="risk-factor-score-impact">
                            <span *ngIf="riskFactor.scoreImpact > 0">+</span>{{ riskFactor.scoreImpact }}
                        </div>
                    </span>
                </div>
            </span>
        </div>
    `,
    styles: [`
        @import "/src/styles/colors";
        @import "/src/styles/settings";

        .uba-panel-box {
            border: 1px solid $gray-5;
            border-radius: 2px;
            margin-top: 10px;
            margin-bottom: 10px;
            margin-right: 24px;
            width: 260px;
            padding: 8px 16px 16px 16px;
        }

        .uba-panel-title {
            font-weight: $font-weight-bold;
            color: $gray-9;
            font-size: 14px;
            line-height: 38px;
            margin: auto;
            margin-left: 0;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 150px;
        }

        .uba-panel-values {
            display: flex;
            flex-direction: row;
            line-height: 200%;
        }

        .dropdown-values {
            padding: 6px;
        }

        .uba-panel-to-from {
            width: 50px;
            color: $gray-6;
            margin-right: 6px;
        }

        .uba-score-impact {
            color: $gray-6;
            display: flex;
        }

        .uba-score {
            margin-left: auto;
            margin-right: 0;
            font-weight: $font-weight-bold;
            color: $gray-9;
        }

        .uba-preview {
            width: 150px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        #ds-dropdown-trigger {
            color: $ds-blue-6;
            font-weight: $font-weight-bold;
        }

        .uba-panel-bar {
            height: 1px;
            border: 1px solid $gray-5;
            margin-top: 2px;
            margin-bottom: 2px;
        }

        .uba-panels {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            margin-bottom: 24px;
            margin-top: 4px;
        }
    `]
})
export class UbaPanelsComponent implements AfterContentInit {
    @Input() riskFactors: RiskFactor[];
    @ViewChild("riskFactorTitle") riskFactorNameElementView: ElementRef;
    hasTitleOverflow: boolean;

    ngAfterContentInit() {
        if (this.riskFactorNameElementView) {
            const valueElementView = this.riskFactorNameElementView.nativeElement;
            this.hasTitleOverflow = valueElementView && (valueElementView.clientWidth < valueElementView.scrollWidth);
        }
    }
}

